import ShopaholicCartPosition from '@lovata/shopaholic-cart/shopaholic-cart-position';
import ShopaholicCartShippingType from '@lovata/shopaholic-cart/shopaholic-cart-shipping-type';
import ShopaholicCart from '@lovata/shopaholic-cart/shopaholic-cart';

export default class ProductCardHelper {
  constructor() {
    this.offersListSelector = '_offers-control__list';
    this.inputQuantity = '_quantity-input';
    this.sizeCheckbox = 'filter-size__checkbox';
    this.quantyIdSelector = 'data-quantity';
    this.sQuantityAttr = 'quantity';
    this.quantityBtn = '_quantity-btn';

    this.sRemoveSelector = null;
    this.sQuantitySelector = null;

    this.quantityTotalSelector = '_quantity-total';
    this.dataProductID = 'data-product-id';
    this.iRadix = 10;

    this.sMiniCartWrapper = '_shopaholic-cart-mini-wrapper';
    this.sUpdateComponentMethod = 'Cart::onUpdate';
    this.obAjaxRequestCallback = null;

    this.iDelayBeforeRequest = 200;
    this.obTimer = null;
    this.init();
  }

  init() {
    this.initUpdateQuantity();
    this.initUpdateButton();
  }

  initAutoUpdateQuantity() {
    const form = document.querySelector(`.${this.offersListSelector}`);
    if (form) {
      const checkbox = form.querySelectorAll('input[type=radio]');
      checkbox.forEach((el) => {
        if (el.checked) {
          const quantity = el.getAttribute(this.quantyIdSelector);
          $(`.${this.inputQuantity}`)
            .attr('max', quantity)
            .val(1);
          $(`.${this.quantityTotalSelector}`)
            .html(quantity);
          // this.setBtnDisabled();
        }
      });
    }
  }

  initUpdateQuantity() {
    // this.initAutoUpdateQuantity();
    $('body')
      .on('click', `.${this.sizeCheckbox}`, ({ target }) => {
        const quantity = target.getAttribute(this.quantyIdSelector);

        $(`.${this.inputQuantity}`)
          .attr('max', quantity)
          .val(1);
        $(`.${this.quantityTotalSelector}`)
          .html(quantity);
        // this.setBtnDisabled();
      });
  }

  initUpdateButton() {
    $(document)
      .on('click', `.${this.sQuantitySelector}-decrease`, (obEvent) => {
        const { currentTarget: obButton } = obEvent;
        this.initDecrease(obButton);
      });
    $(document)
      .on('click', `.${this.sQuantitySelector}-increase`, (obEvent) => {
        const { currentTarget: obButton } = obEvent;
        this.initIncrease(obButton);
      });
  }

  initDecrease(obButton) {
    if (this.obTimer !== null) {
      clearTimeout(this.obTimer);
    }

    this.obTimer = setTimeout(() => {
      const productID = obButton.getAttribute(this.dataProductID);
      const quantityInput = this.getQuantityInput(productID);
      let iQuantity = this.getQuantity(quantityInput) - 1;
      this.removeBtnDisabled(productID);
      const obCartPosition = new ShopaholicCartPosition(obButton);
      const obInput = obCartPosition.getQuantityInput();

      if (iQuantity < 1) {
        iQuantity = 1;
      }

      if (iQuantity === 1) {
        obButton.classList.remove(`${this.sQuantitySelector}-decrease`);
        // eslint-disable-next-line sonarjs/no-duplicate-string
        obButton.classList.add('remove-product-btn');
        obButton.classList.add(this.sRemoveSelector);
      } else {
        obButton.classList.remove(this.sRemoveSelector);
        obButton.classList.remove('remove-product-btn');
        obButton.classList.add(`${this.sQuantitySelector}-decrease`);
      }

      $(`.${this.inputQuantity}-${productID}`)
        .val(iQuantity);
      this.sendAjaxRequest(obInput);
    }, this.iDelayBeforeRequest);
  }

  initIncrease(obButton) {
    if (this.obTimer !== null) {
      clearTimeout(this.obTimer);
    }
    this.obTimer = setTimeout(() => {
      const productID = obButton.getAttribute(this.dataProductID);
      this.removeBtnDisabled(productID);
      const obCartPosition = new ShopaholicCartPosition(obButton);
      const obInput = obCartPosition.getQuantityInput();
      const quantityInput = this.getQuantityInput(productID);
      const iMaxQuantity = this.getMaxQuantity(quantityInput);
      let iQuantity = this.getQuantity(quantityInput) + 1;

      if (iQuantity === iMaxQuantity) {
        iQuantity = iMaxQuantity;
        obButton.setAttribute('disabled', 'disabled');
      } else {
        obButton.removeAttribute('disabled');
      }

      $(`.${this.inputQuantity}-${productID}`)
        .val(iQuantity);
      this.sendAjaxRequest(obInput);
    }, this.iDelayBeforeRequest);
  }

  getQuantityInput(productID) {
    return document.querySelector(`.${this.inputQuantity}-${productID}`);
  }

  getQuantity(quantityInput) {
    return parseInt(quantityInput.value, this.iRadix);
  }

  getMaxQuantity(quantityInput) {
    return parseInt(quantityInput.getAttribute('max'), this.iRadix);
  }

  setBtnDisabled() {
    const quantityInput = this.getQuantityInput();
    const iMaxQuantity = this.getMaxQuantity(quantityInput);

    const obIncreaseButton = document.querySelector(`.${this.sQuantitySelector}-increase`);
    if (iMaxQuantity === 1) {
      obIncreaseButton.setAttribute('disabled', 'disabled');
    } else {
      obIncreaseButton.removeAttribute('disabled');
    }
  }

  removeBtnDisabled(productId) {
    const buttons = document.querySelectorAll(`.${this.quantityBtn}-${productId}`);
    if (!buttons) return;
    buttons.forEach((button) => {
      button.classList.remove(this.sRemoveSelector);
      button.classList.remove('remove-product-btn');
      button.classList.add(`${this.sQuantitySelector}-decrease`);
    });
  }

  sendAjaxRequest(obInput) {
    if (!obInput) {
      throw new Error('Input node is empty.');
    }

    const obCartPosition = new ShopaholicCartPosition(obInput);
    const obPositionData = obCartPosition.getData();
    const obShippingType = new ShopaholicCartShippingType();

    let obRequestData = {
      data: {
        cart: [obPositionData],
        shipping_type_id: obShippingType.getShippingTypeID(),
      },
      update: { 'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}` },
      complete: ({ responseJSON }) => {
        this.completeCallback(responseJSON);
      },
    };

    if (this.obAjaxRequestCallback !== null) {
      obRequestData = this.obAjaxRequestCallback(obRequestData, obInput);
    }

    $.request(this.sUpdateComponentMethod, obRequestData);
  }

  // eslint-disable-next-line class-methods-use-this
  completeCallback(obResponse) {
    const { data: obCartData } = obResponse;

    ShopaholicCart.instance().updateCartData(obCartData);
  }

  setRemoveSelector(sRemoveSelector) {
    this.sRemoveSelector = sRemoveSelector;

    return this;
  }

  setQuantitySelector(sQuantitySelector) {
    this.sQuantitySelector = sQuantitySelector;
    return this;
  }
}
